import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { Dropdown } from 'react-bootstrap'
import {
  addressContainer,
  customerContainer,
  subscriptionContainer,
} from 'src/models'
import { application, getConvertedMonth, getConvertedYear } from 'src/utils'
import { getAppConfig } from 'config/appConfig'
import { Link } from 'react-router-dom'
import { i18nTranslate } from 'src/utils'
import { dateFormatDeps } from 'src/deps'
import './styles.scss'

@observer
class ShowAll extends React.Component {
  @observable isEditShippingAddress = false
  @observable isEditPayments = false
  @observable isEditShippingMethod = false
  @observable disablePaymentEdit = false
  @observable disableShippingEdit = false
  @observable enablePaymentModal = false
  @observable isPaymentCallInProgress = false
  @observable isShippingAddressCallInProgress = false
  @observable isShippingMethodCallInProgress = false
  @observable isAddressEditModal = false
  @observable editSubscriptionAddress = {}
  subscriptionPaymentId = ''
  subscriptionShippingAddressId = ''
  selectedShippingAddressId = ''
  newAddressToUpdate = ''
  subscriptionShipping = ''

  async componentDidMount() {
    const token = this.props?.location.queryParams.token || ''
    if (!token) {
      addressContainer.getProfileAddress()
      await customerContainer.getPaymentsForDashboard()
    }
  }

  onMobileMonthDropdownClick = (value, showall, month) => {
    subscriptionContainer.resetSubscriptionResponse(showall, month)
    this.props.history.push({
      search: value,
    })
  }

  renderUpcomingFiveMonthsMobile = (startMonth, selectedMonth) => {
    if (startMonth <= 0) {
      return ''
    }
    let i = 1
    let queryParam = this.props?.location?.queryParams?.month || ''
    let currentMonth = startMonth
    let newMonths = []
    let date = new Date()
    let year = date.getFullYear()
    let newYear = year
    for (i = 1; i <= 5; i++) {
      if (currentMonth > 12) {
        newYear = year + 1
      }
      let currentDate = new Date(newYear, currentMonth - 1, 1)
      let monthName = currentDate.toLocaleString('default', { month: 'short' })
      let month = currentDate.getMonth()

      newMonths.push(
        <Dropdown.Item
          className="subscription-month-dropdown-values"
          as="button"
          key={i}
          data-testid={`qa-user-sub-upcoming-delivery-month-${i}`}
          onClick={() =>
            this.onMobileMonthDropdownClick(
              `?month=${month + 1}`,
              false,
              month + 1
            )
          }>
          <span className="subscription-month-dropdown-link">{`${monthName} ${newYear}`}</span>
        </Dropdown.Item>
      )
      currentMonth = startMonth + i
    }
    newMonths.push(
      <Dropdown.Item
        className="subscription-month-dropdown-values"
        as="button"
        key={i}
        data-testid={`qa-user-sub-upcoming-delivery-month`}
        onClick={() =>
          this.onMobileMonthDropdownClick(`?month=showall`, true, '')
        }>
        <span className="subscription-month-dropdown-link">{`SHOW ALL`}</span>
      </Dropdown.Item>
    )
    let selectedDate = new Date(newYear, selectedMonth - 1, 1)
    const selectedMonthName = selectedDate.toLocaleString('default', {
      month: 'short',
    })
    let currentSelectedMonth =
      startMonth > selectedMonth ? 12 + selectedMonth : selectedMonth

    // currentSelectedMonth > 12 ? date.getFullYear() + 1 : date.getFullYear()

    const getShortMonth = {
      1: 'Jan',
      2: 'Feb',
      3: 'Mar',
      4: 'Apr',
      5: 'May',
      6: 'Jun',
      7: 'Jul',
      8: 'Aug',
      9: 'Sep',
      10: 'Oct',
      11: 'Nov',
      12: 'Dec',
      showall: 'Show All',
    }
    return (
      <Dropdown className="subscription-month-dropdown">
        <Dropdown.Toggle
          className="subscription-month-dropdown-toggle w-100 d-flex align-items-center rounded-0 shadow-none"
          variant="">
          <span className="subscription-month-dropdown-text text-capitalize">
            {!queryParam
              ? `${getShortMonth[new Date().getMonth() + 1]} ${newYear}`
              : queryParam == 'showall'
              ? `${getShortMonth[queryParam]}`
              : `${getShortMonth[queryParam]} ${newYear}`}
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu data-testid="qa-dropdown" className="rounded-0 w-100">
          {newMonths}
        </Dropdown.Menu>
      </Dropdown>
    )
  }

  renderUpcomingFiveMonths = (startMonth, selectedMonth) => {
    if (startMonth <= 0) {
      return ''
    }
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const timeZone =
      subscriptionContainer.subscriptionPreferenceResponse?.timeZone ||
      'US/Mountain'

    let currentMonth = startMonth
    let newMonths = []
    const currentSubscriptionMonth = getConvertedMonth(
      currentDateInMillis,
      timeZone
    )
    // let year = new Date(currentDateInMillis).toLocaleDateString([], {
    //   timeZone,
    //   year: 'numeric',
    // })
    const year = getConvertedYear(currentDateInMillis, timeZone)

    let newYear = year
    let queryParam = this.props?.location?.queryParams?.month || ''

    for (let i = 1; i <= 1; i++) {
      if (currentSubscriptionMonth == 12 && currentMonth == 1) {
        newYear = parseInt(year) + 1
      }
      let monthName = dateFormatDeps.matchMonthFromNumberToString(currentMonth)
      this.props.setProcessingMonth(monthName)
      monthName = monthName.substr(0, 3)
      let month = currentMonth
      let isMonthActive =
        selectedMonth == startMonth &&
        queryParam !== 'showall' &&
        queryParam !== 'pvassistant'
      newMonths.push(
        <div
          className={`month-list ${isMonthActive ? 'selected' : ''}`}
          data-testid={`qa-user-sub-upcoming-delivery-month-${i}`}>
          <Link
            aria-label={`${monthName} ${newYear} ${i18nTranslate(
              'subscription.monthLink',
              'Subscription details'
            )}`}
            to={`?month=${month}${
              subscriptionContainer.allUsers &&
              this.props.selectedUser.buyerInfo
                ? '&id=' + this.props.selectedUser?.buyerInfo?.id
                : ''
            }`}
            onClick={() =>
              subscriptionContainer.resetSubscriptionResponse(
                false,
                month + 1,
                subscriptionContainer.allUsers
              )
            }>{`${monthName} ${newYear}`}</Link>
        </div>
      )
      currentMonth = startMonth + i
    }

    newMonths.push(
      <div
        className={`month-list show ${
          queryParam === 'showall' ? 'selected' : ''
        }`}
        data-testid={`qa-user-sub-upcoming-delivery-month`}>
        <Link
          to={`?month=showall${
            subscriptionContainer.allUsers && this.props.selectedUser.buyerInfo
              ? '&id=' + this.props.selectedUser.buyerInfo.id
              : ''
          }`}
          onClick={() =>
            subscriptionContainer.resetSubscriptionResponse(
              true,
              '',
              subscriptionContainer.allUsers
            )
          }>
          {i18nTranslate('subscription.viewAll', 'View All')}
        </Link>
      </div>
    )

    if (getAppConfig().shouldShowPvAssit) {
      newMonths.push(
        <div
          className={`col-md-1 month-list ${
            queryParam === 'pvassistant' ? 'selected' : ''
          }`}
          data-testid={`qa-user-sub-upcoming-delivery-month`}>
          <Link
            to={`?month=pvassistant`}
            onClick={() =>
              subscriptionContainer.resetSubscriptionResponse(
                false,
                '',
                subscriptionContainer.allUsers
              )
            }>
            pv assistant
          </Link>
        </div>
      )
    }
    return newMonths
  }

  render() {
    const { timeZone = 'US/Mountain' } =
      subscriptionContainer.subscriptionPreferenceResponse
    const { csrAdminCookie } = getAppConfig()
    // getCookie(csrAdminCookie) ? true : false
    const subscriptionProducts = subscriptionContainer.selectedSubscription
    const apiStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.apiStatus
    const isServiceFailure =
      subscriptionContainer.subscriptionPreferenceResponse?.isServiceFailure ||
      false
    const month = this.props?.location?.queryParams?.month || ''
    let selectedMonth = 0
    const currentDateInMillis =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.currentDateInMillis || ''
    const lastOrderProcessingDate =
      subscriptionContainer.subscriptionPreferenceResponse
        ?.lastOrderProcessingDate || 0
    const lastOrderProcessedMonth = getConvertedMonth(
      lastOrderProcessingDate,
      timeZone
    )
    const currentMonth = getConvertedMonth(currentDateInMillis, timeZone)
    const lastSubscriptionOrderStatus =
      subscriptionContainer.subscriptionPreferenceResponse?.lastOrderStatus ||
      ''
    selectedMonth =
      lastSubscriptionOrderStatus.toLowerCase() == 'order_success' &&
      lastOrderProcessedMonth == currentMonth
        ? currentMonth + 1 > 12
          ? 1
          : currentMonth + 1
        : currentMonth
    const customClassName =
      !application.isMobile && subscriptionContainer.isPreferenceAPIInProgress
        ? 'disabled'
        : ''

    return (
      <div
        className={`${
          month === 'showall' ? 'show-list' : 'show-all'
        } d-flex w-50 h-50 pl-4 align-self-center`}>
        {selectedMonth &&
        subscriptionContainer.subscriptionPreferenceResponse
          ?.selectedSubscriptions
          ? this.renderUpcomingFiveMonths(selectedMonth, selectedMonth)
          : ''}
      </div>
    )
  }
}

export default ShowAll
export { ShowAll }
